import { jsx, jsxs } from 'react/jsx-runtime';
import cn from 'classnames';
import { Card, Space } from '@sravni/react-design-system';
import '@sravni/react-design-system/lib/Typography';
import './components/WithIcon/WithIcon.module.scss.js';
import './components/CardIcon/CardIcon.module.scss.js';
import { CardTitle } from './components/CardTitle/CardTitle.js';
import 'react';
import '@sravni/react-icons';
import './components/OfferParam/OfferParam.module.scss.js';
import { OfferParams } from './components/OfferParams/OfferParams.js';
import './components/Subtitles/Subtitles.module.scss.js';
import 'tslib';
import 'date-fns';
import './components/Notifications/Notifications.module.scss.js';
import modules_645d8c13 from './OfferCard.module.scss.js';

var OfferCard = function (_a) {
    var _b;
    var title = _a.title, icon = _a.icon, subtitle = _a.subtitle, badges = _a.badges, summary = _a.summary, controls = _a.controls, withBorder = _a.withBorder, onClick = _a.onClick, rating = _a.rating, reviews = _a.reviews;
    return (jsx(Card, { size: 16, className: cn(modules_645d8c13.card, (_b = {}, _b[modules_645d8c13.withBorder] = withBorder, _b[modules_645d8c13.clickable] = onClick, _b)), onClick: onClick, children: jsxs(Space, { direction: "vertical", size: 16, justify: "space-between", children: [jsxs(Space, { direction: "vertical", size: 16, children: [jsx(CardTitle, { title: title, icon: icon, subtitle: subtitle, rating: rating, reviews: reviews }), (badges === null || badges === void 0 ? void 0 : badges.length) && (jsx(Space, { size: 8, wrap: true, children: badges })), jsx(OfferParams, { children: summary })] }), !!(controls === null || controls === void 0 ? void 0 : controls.length) && jsx(Space, { children: controls })] }) }));
};

export { OfferCard };
//# sourceMappingURL=OfferCard.js.map
